export default __webpack_public_path__ + "static/media/(93).d97cd120.jpg";